import { AppConfigService } from "./app-config.service";
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpService } from "./http.service";

@Injectable({ providedIn: 'root' })

export class TermsService {
  constructor(private appConfigService: AppConfigService, private httpService: HttpService) {
  }

  public getTermsAndConditions(): Observable<any> {
    var requestApiUrl = `${this.appConfigService.getLoadedConfig().communityApiUrl}/api/sl/terms/terms-and-conditions`;
    return this.httpService.get(requestApiUrl, 'text');
  }

  public getPrivacyPolicy(): Observable<any> {
    var requestApiUrl = `${this.appConfigService.getLoadedConfig().communityApiUrl}/api/sl/terms/privacy-notes`;
    return this.httpService.get(requestApiUrl, 'text');
  }
}
